import { toast } from 'sonner';

/**
 * Thin wrapper around sonner's toast API.
 * Centralises toast usage so we can swap the underlying library,
 * add analytics, or customise behaviour in one place.
 */
export function useToast() {
  return { toast };
}
